import React from 'react';

import RichTextViewer from '@/components/RichTextViewer';

import { useBaseCard } from '../Provider';
import type { BaseCardComposition } from '../types';

const Description: BaseCardComposition['Description'] = (props) => {
  const { description } = useBaseCard();

  if (!description) {
    return null;
  }

  return (
    <RichTextViewer
      truncate
      color="text-text-secondary"
      html={description}
      truncateLength={70}
      variant="body-short-02"
      {...props}
    />
  );
};

export default Description;
